export default __webpack_public_path__ + "static/Economic Model Update - Chinese-0aedf17ab6beeffb0634ded6ba60b1b1.pdf";